{
  "$schema": "./partners.schema.json",
  "partners": {
    "qvest-media": {
      "name": "Qvest Media",
      "logo": "/assets/partners/qvest-media.svg",
      "address": "Qvest GmbH\nMathias-Brüggen-Str. 65a\n50829 Köln-Ossendorf\nGermany",
      "phone": "+4922191560",
      "website": "https://www.qvestmedia.com/"
    },
    "dve-as": {
      "name": "netorium AG",
      "logo": "/assets/partners/netorium.svg",
      "address": "netorium AG\nMax Planck Str. 6\n85609 Aschheim\nGermany",
      "phone": "",
      "website": "https://www.netorium.de/",
      "remarks": "Renamed to netorium AG due to acquisition",
      "deprecated": true
    },
    "netorium": {
      "name": "netorium AG",
      "logo": "/assets/partners/netorium.svg",
      "address": "netorium AG\nMax Planck Str. 6\n85609 Aschheim\nGermany",
      "phone": "",
      "website": "https://www.netorium.de/"
    },
    "studio-hamburg-mci": {
      "name": "Studio Hamburg Media Consult International",
      "logo": "/assets/partners/mci-hamburg.png",
      "address": "Studio Hamburg Media Consult International (MCI) GmbH\nJenfelder Allee 80\n22039 Hamburg\nGermany",
      "phone": "+494066883616",
      "website": "https://mci-shop.de/"
    },
    "mediatec": {
      "name": "Mediatec",
      "logo": "/assets/partners/mediatec.png",
      "address": "Mediatec GmbH\nWiddersdorfer Straße 217\n50825 Köln\nGermany",
      "phone": "+4922188800",
      "website": "https://mediatec.de/"
    },
    "video-progetti": {
      "name": "Video Progetti",
      "logo": "/assets/partners/video-progetti.svg",
      "address": "Video Progetti Roma\nVia Cosimo Tornabuoni 21, 00166 Roma (RM)\nItaly\n\nVideo Progetti Milano\n+39 028930 5809\nVia Rivoltana 35, 20096 Pioltello (MI)\nItaly",
      "phone": "+39066129641",
      "website": "https://www.videoprogetti.it/"
    },
    "post-logic": {
      "name": "Post Logic",
      "logo": "/assets/partners/post-logic.png",
      "address": "Post Logic\n2, Rue de Longchamp\n92200 Neuilly / Seine\nFrance",
      "phone": "+33146377761",
      "website": "https://post-logic.com/"
    },
    "xtfx": {
      "name": "XTFX",
      "logo": "/assets/partners/xtfx.png",
      "address": "XTFX Ltd\nThe Light Bulb\nFilament Walk,\nWandsworth\nLondon SW18 4GQ\nUnited Kingdom",
      "phone": "+442076367855",
      "website": "https://xtfx.co.uk/"
    },
    "stjernholm": {
      "name": "Stjernholm & Co A/S",
      "logo": "/assets/partners/stjernholm.svg",
      "address": "Marielundvej 46E, 1 sal th\n2730 Herlev\nDenmark",
      "phone": "+4570237108",
      "website": "https://stjernholmco.dk/"
    },
    "alt-systems": {
      "name": "ALT systems",
      "logo": "/assets/partners/alt-systems.svg",
      "address": "ALT Systems\n7642 Clybourn Avenue\nSun Valley, CA 91352\nUSA",
      "phone": "+18185046800",
      "website": "https://altsystems.com/"
    },
    "rocket-science": {
      "name": "Rocket Science",
      "logo": "/assets/partners/rocket-science.svg",
      "address": "RocketScience\nSuite 5, First Floor, The Core\nC/o Kikuyu & Leeukop Rd\nSunninghill, 2157\nJohannesburg, South Africa",
      "phone": "+27117450060",
      "website": "https://rocketscience.co.za/"
    },
    "exectec": {
      "name": "ExecTechnology",
      "logo": "/assets/partners/exectec.svg",
      "address": "ExecTechnology\nRua Augusto Ribeiro Filho, 74\nSao Paulo, SP\n04614-020, Brasil",
      "phone": "+551150416966 +541166322113",
      "website": "https://www.exectec.com.br/"
    },
    "cev": {
      "name": "CEV",
      "logo": "/assets/partners/cev.svg",
      "address": "CEV Montréal\n3055 Adam\nMontreal QC,\nCanada, H1W 3Y7",
      "phone": "+18003378835 +15145218253",
      "website": "https://www.cev.ca/"
    },
    "agora": {
      "name": "AGORA plus",
      "logo": "/assets/partners/agora.svg",
      "address": "AGORA plus, a.s.\nRipska 11c\n627 00 Brno\nCzech Republic",
      "phone": "+420515913850",
      "website": "https://www.agoraplus.cz"
    },
    "studiotech": {
      "name": "STUDIOtech",
      "logo": "/assets/partners/studiotech.svg",
      "address": "Studiotech SP. Z oo\nul. Bażancia 53\n02-892 Warschau\nPoland",
      "phone": "+48226441025",
      "website": "https://www.studiotech.pl/"
    },
    "futurestore": {
      "name": "The Future Store",
      "logo": "/assets/partners/futurestore.png",
      "address": "The Future Store\nHelling 466\n3523 CC Utrecht\nNetherlands",
      "phone": "+31302316360",
      "website": "https://futurestore.nl/"
    },
    "creativetools": {
      "name": "Creative Tools",
      "logo": "/assets/partners/creativetools.svg",
      "address": "Janusz Rupik PVP sp. z o. o.\nRumiana 108 a\n02-956 Warszawa\nPoland",
      "phone": "+48222570080",
      "website": "https://www.creativetools.pl/"
    },
    "boneheadz": {
      "name": "boneheadZ",
      "logo": "/assets/partners/boneheadz.png",
      "address": "boneheadZ\nRačianska 124\n831 54 Bratislava\nSlovakia",
      "phone": "+421232661451",
      "website": "https://www.boneheadzsystems.sk/"
    },
    "baran": {
      "name": "Baran",
      "logo": "/assets/partners/baran.svg",
      "address": "Baran Bilisim Teknolojileri\nCumhuriyet Mah. Ergenekon Cad. No. 50/A\nBomonti Sisli – Istanbul\nTurkey",
      "phone": "+902123431368",
      "website": "https://baranbilisim.com.tr/"
    },
    "qsmartstorage": {
      "name": "Econocom Products & Solutions",
      "logo": "/assets/partners/econocom.svg",
      "address": "Econocom Products & Solutions UK Ltd.\n33 Queen Street,\nOffice 02-101,\nLondon,\nEC4R 1AP\nUnited Kingdom",
      "phone": "+442078207111",
      "website": "https://www.econocom.com/"
    },
    "addigital": {
      "name": "AD Digital",
      "logo": "/assets/partners/addigital.png",
      "address": "AD Digital\n1742, Jau Alley\nSão Paulo/SP\nBrazil",
      "phone": "+551134673353",
      "website": "https://www.ad-digitaltecnologia.com.br/"
    },
    "contentaware": {
      "name": "Content Aware Solutions",
      "logo": "/assets/partners/contentaware.png",
      "address": "Content Aware Solutions Inc.\n901 King St West - Suite 400\nToronto ON\nCanada, M5V 3H5",
      "phone": "+14169012608",
      "website": "https://www.contentaware.ca/"
    },
    "ipmedia": {
      "name": "IP Media Solutions",
      "logo": "/assets/partners/ipmedia.svg",
      "address": "IP Media Solutions\n236 Albany Heights Rd\nRD2 Albany\nAuckland 0792\nNew Zealand",
      "phone": "",
      "website": "https://ipmedia.nz/"
    },
    "newmediahollywood": {
      "name": "New Media Hollywood",
      "logo": "/assets/partners/newmediahollywood.png",
      "address": "New Media Hollywood\n6150 Santa Monica Blvd.\nHollywood, CA 90038\nUSA",
      "phone": "+13239575000",
      "website": "https://nmh.com/"
    },
    "imt": {
      "name": "Integrated Media Technologies Inc.",
      "logo": "/assets/partners/imt.png",
      "address": "5200 Lankershim Blvd., Ste. 700\nNorth Hollywood, CA 91601",
      "phone": "+18777619770",
      "website": "https://imtglobalinc.com/"
    },
    "cinesys": {
      "name": "CineSys-Oceana",
      "logo": "/assets/partners/cinesys.png",
      "address": "5104 Lillian Street\nHouston, TX 77007\nUSA",
      "phone": "+18669052050",
      "website": "https://cinesysoceana.com/"
    },
    "tvtools": {
      "name": "Media Tailor",
      "logo": "/assets/partners/media-tailor.svg",
      "address": "Media Tailor\nIso Paja\nRadiokatu 3\n00240 Helsinki\nFinland",
      "phone": "+35895259700",
      "website": "https://mediatailor.fi/"
    },
    "cbc": {
      "name": "RTL",
      "logo": "/assets/partners/rtl.png",
      "address": "RTL Technology GmbH\nPicassoplatz 1\n50679 Köln\nGermany",
      "phone": "+4922145640",
      "website": "https://company.rtl.com/de/about-rtl/overview/profile/",
      "remarks": "Renamed CBC to RTL. Keeping this legacy entry for compatibility.",
      "deprecated": true
    },
    "rtl": {
      "name": "RTL",
      "logo": "/assets/partners/rtl.png",
      "address": "RTL Technology GmbH\nPicassoplatz 1\n50679 Köln\nGermany",
      "phone": "+4922145640",
      "website": "https://company.rtl.com/de/about-rtl/overview/profile/"
    },
    "provideo": {
      "name": "PRO VIDEO",
      "logo": "/assets/partners/provideo.png",
      "address": "PRO VIDEO Berlin\nWittestraße 30 K\n13509 Berlin\nGermany",
      "phone": "+49304356050",
      "website": "https://www.provideo.eu/"
    },
    "videopeople": {
      "name": "Video People",
      "logo": "/assets/partners/video-people.png",
      "address": "VIDEO PEOPLE\nHolsbjergvej 43\n2620 Albertslund\nDenmark",
      "phone": "+4553600920",
      "website": "https://videopeople.dk/"
    },
    "videoutstyr": {
      "name": "VideoUtstyr",
      "logo": "/assets/partners/videoutstyr.png",
      "address": "VideoUtstyr Norge AS\nStanseveien 4\n0975 Oslo\nNorway",
      "phone": "+4722804000",
      "website": "https://videoutstyr.no/"
    },
    "kst-moschkau": {
      "name": "KST Moschkau",
      "logo": "/assets/partners/kst-moschkau.png",
      "address": "KST Moschkau\nAm Burgholz 36\n52372 Kreuzau-Stockheim\nGermany",
      "phone": "+49242155890",
      "website": "https://kst-moschkau.eu/"
    },
     "mr-systems": {
      "name": "MR Systems PLC",
      "logo": "/assets/partners/mr-systems.svg",
      "address": "MR Systems PLC\nSystems House\n383–385 Liverpool Road\nLondon N1 1NP\nUnited Kingdom",
      "phone": "+442036277030",
      "website": "https://mrsystems.co.uk/"
    }
  }
}
